/*
  Use this hook to monitor visibility state of the page.
  When user change a tab hook will call a callback with isHidden property.

  Example:

  const App = () => {
    // useEffect...
    const onPageVisibilityChange = (isHidden) => {
      if (isHidden) {
        // page was visible and became hidden
      }
      else {
        // page was hidden and became visible
      }
    }

    usePageVisibility(onPageVisibilityChange)

    return (
      <div>Something</div>
    )
  }

 */


import { useEffect } from 'react'


let hidden
let visibilityChange

if (typeof document !== 'undefined') {
  if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden'
    visibilityChange = 'visibilitychange'
  }
  else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden'
    visibilityChange = 'msvisibilitychange'
  }
  else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden'
    visibilityChange = 'webkitvisibilitychange'
  }
}

const usePageVisibility = (onVisibilityChange) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      const isHidden = Boolean(document[hidden])
      onVisibilityChange(isHidden)
    }

    if (hidden !== undefined) {
      document.addEventListener(visibilityChange, handleVisibilityChange, false)
    }

    return () => {
      if (hidden !== undefined) {
        document.removeEventListener(visibilityChange, handleVisibilityChange, false)
      }
    }
  }, [ onVisibilityChange ])
}


export default usePageVisibility
